import React from "react";
import styled from "styled-components";
import { ElementContainer } from "../../containers/styledComponents";
import { Filter as Option } from "../../../types/PageFilterTypes";
import { DynamicRenderContent } from "./DynamicContentRender";
import { darkGreen } from "../../../styles";
import { Checkbox } from "../Checkbox";
import { MESSAGES } from "../../../messages";

const SelectionItem = styled.div<{ shouldDisplay?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: ${({ shouldDisplay }): string =>
    shouldDisplay ? "auto" : "300px"};
  padding: 7px 10px;
  cursor: pointer;
  background-color: transparent;
  font-family: Apercu;
  margin-top: 2px;
  margin-left: 10px;
  margin-right: 10px;
  width: 100%;

  &:hover {
    color: ${darkGreen};
  }
`;
export function FilterList({
  option,
  handleSelectOption,
  checked,
  isMultiSelect,
  animate = true,
}: FilterListProps): JSX.Element {
  return (
    <ElementContainer onClick={(): void => handleSelectOption(option)}>
      <SelectionItem shouldDisplay={!!option.component}>
        {isMultiSelect &&
          option.displayValue !== MESSAGES.NO_FILTER_APPLIED && (
            <Checkbox checked={checked} size={20} />
          )}
        {<DynamicRenderContent option={option} animate={animate} />}
      </SelectionItem>
    </ElementContainer>
  );
}

type FilterListProps = {
  option: Option;
  checked: boolean;
  isMultiSelect: boolean;
  handleSelectOption: (option: Option) => void;
  animate?: boolean;
};
